import React, { useRef } from "react";

const canHover = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(hover: hover) and (pointer: fine)").matches &&
  !window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/**
 * Wraps a link/button so it drifts slightly toward the cursor.
 * No-op on touch devices and when reduced motion is requested.
 */
export default function Magnetic({ children, strength = 0.28, className = "" }) {
  const wrapRef = useRef(null);

  const handleMove = (event) => {
    if (!canHover()) return;
    const el = wrapRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = (event.clientX - (rect.left + rect.width / 2)) * strength;
    const y = (event.clientY - (rect.top + rect.height / 2)) * strength;
    el.style.transform = `translate3d(${x.toFixed(2)}px, ${y.toFixed(2)}px, 0)`;
  };

  const handleLeave = () => {
    const el = wrapRef.current;
    if (el) el.style.transform = "";
  };

  return (
    <span
      ref={wrapRef}
      className={`magnetic ${className}`.trim()}
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
      style={{ display: "inline-flex", transition: "transform 0.45s cubic-bezier(0.22,1,0.36,1)" }}
    >
      {children}
    </span>
  );
}
